<template>
  <div class="join-class-mobile">
    <el-card class="join-class-card">
      <div slot="header" class="join-class-header">
        <el-button type="text" icon="el-icon-arrow-left" @click="goToHome" class="back-button">返回</el-button>
        <h2>加入班级</h2>
        <div v-if="teacherInfo" class="teacher-info">
          尊敬的{{ teacherInfo.nickname }}，<br>您已绑定{{ boundClassCount }}个班级，一位老师最多绑定{{ maxClasses }}个班级
        </div>
      </div>
      
      <el-form :model="joinClassForm" :rules="joinClassRules" ref="joinClassForm" label-width="100px" class="join-class-form">
        <el-form-item label="班级级别" prop="gradeLevel">
          <el-select v-model="joinClassForm.gradeLevel" placeholder="请选择班级级别" style="width: 100%;">
            <el-option
              v-for="grade in gradeOptions"
              :key="grade.value"
              :label="grade.label"
              :value="grade.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="班级班别" prop="classNumber">
          <el-select v-model="joinClassForm.classNumber" placeholder="请选择班级班别" style="width: 100%;">
            <el-option
              v-for="classNum in classNumberOptions"
              :key="classNum.value"
              :label="classNum.label"
              :value="classNum.value">
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="识别码" prop="classCode">
          <el-input v-model="joinClassForm.classCode" placeholder="请输入5位数字组成的识别码" maxlength="5"></el-input>
        </el-form-item>
        
        <el-form-item label="任教科目" prop="subjectId">
          <el-select v-model="joinClassForm.subjectId" placeholder="请选择任教科目" style="width: 100%;" @change="onSubjectChange">
            <el-option label="语文" :value="1"></el-option>
            <el-option label="数学" :value="2"></el-option>
            <el-option label="英语" :value="3"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="作业类型" prop="homeworkTypes">
          <div class="homework-types-container">
            <el-tree
              class="homework-types-tree"
              :data="treeData"
              :props="defaultProps"
              :expand-on-click-node="false"
              node-key="id"
              highlight-current
              :default-expanded-keys="expandedKeys">
              <span class="custom-tree-node" slot-scope="{ node, data }" style="display: flex; align-items: center; justify-content: space-between; font-size: 14px; width: 100%;">
                <span class="node-label" style="flex: 1; min-width: 0;">{{ node.label }}</span>
                <span v-if="data.type === 'subject'" class="node-actions" style="margin-left: 10px; display: flex; align-items: center;">
                  <el-button
                    type="text"
                    size="mini"
                    :disabled="isHomeworkTypeLimitReached(data)"
                    @click="() => showAddHomeworkTypeDialog(data)">
                    添加作业类型
                  </el-button>
                </span>
                <span v-else class="node-actions" style="margin-left: 10px; display: flex; align-items: center;">
                  <el-button
                    type="text"
                    size="mini"
                    @click="() => renameNode(node, data)">
                    重命名
                  </el-button>
                  <el-button
                    type="text"
                    size="mini"
                    @click="() => moveUp(node, data)">
                    上移
                  </el-button>
                  <el-button
                    type="text"
                    size="mini"
                    @click="() => moveDown(node, data)">
                    下移
                  </el-button>
                  <el-button
                    type="text"
                    size="mini"
                    @click="() => remove(node, data)">
                    删除
                  </el-button>
                </span>
              </span>
            </el-tree>
          </div>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleJoinClass" :loading="loading" class="full-width-btn">加入班级</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>


export default {
  name: 'JoinClassMobile',
  async created() {
    try {
      const teacherInfo = JSON.parse(localStorage.getItem('teacherInfo'));
      if (!teacherInfo) {
        this.$message.error('请先登录');
        this.$router.push('/loginmobile');
        return;
      }
      
      await this.$http.get(`/teachers/profile`);
      
      this.teacherInfo = teacherInfo;
      await this.fetchClassCounts();
    } catch (error) {
      if (error.response && error.response.status === 401) {
        this.$message.error('登录已过期，请重新登录');
        this.$router.push('/loginmobile');
      }
    }
  },
  data() {
    return {
      loading: false,
      teacherInfo: null,
      boundClassCount: 0,
      maxClasses: 5,
      gradeOptions: [
        { value: 1, label: '一年级' },
        { value: 2, label: '二年级' },
        { value: 3, label: '三年级' },
        { value: 4, label: '四年级' },
        { value: 5, label: '五年级' },
        { value: 6, label: '六年级' },
        { value: 7, label: '七年级' },
        { value: 8, label: '八年级' },
        { value: 9, label: '九年级' },
        { value: 10, label: '十年级' },
        { value: 11, label: '十一年级' },
        { value: 12, label: '十二年级' }
      ],
      classNumberOptions: [
        { value: 1, label: '1班' },
        { value: 2, label: '2班' },
        { value: 3, label: '3班' },
        { value: 4, label: '4班' },
        { value: 5, label: '5班' },
        { value: 6, label: '6班' },
        { value: 7, label: '7班' },
        { value: 8, label: '8班' },
        { value: 9, label: '9班' },
        { value: 10, label: '10班' },
        { value: 11, label: '11班' },
        { value: 12, label: '12班' },
        { value: 13, label: '13班' },
        { value: 14, label: '14班' },
        { value: 15, label: '15班' },
        { value: 16, label: '16班' },
        { value: 17, label: '17班' },
        { value: 18, label: '18班' },
        { value: 19, label: '19班' },
        { value: 20, label: '20班' }
      ],
      joinClassForm: {
        gradeLevel: null,
        classNumber: null,
        classCode: '',
        subjectId: null
      },
      joinClassRules: {
        gradeLevel: [
          { required: true, message: '请选择班级级别', trigger: 'change' }
        ],
        classNumber: [
          { required: true, message: '请选择班级班别', trigger: 'change' }
        ],
        classCode: [
          { required: true, message: '请输入识别码', trigger: 'blur' },
          { pattern: /^\d{5}$/, message: '请输入5位数字组成的识别码', trigger: 'blur' }
        ],
        subjectId: [
          { required: true, message: '请选择任教科目', trigger: 'change' }
        ]
      },
      // 作业类型相关数据
      subjects: [
        { id: 1, name: '语文' },
        { id: 2, name: '数学' },
        { id: 3, name: '英语' }
      ],
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      expandedKeys: []
    }
  },
  mounted() {
    // 设置body的padding为0
    document.body.classList.add('mobile-view');
    document.body.classList.add('no-padding');
    document.body.style.padding = '0';
    document.body.style.margin = '0';
  },
  beforeDestroy() {
    // 组件销毁前恢复body的默认样式
    document.body.classList.remove('mobile-view');
    document.body.classList.remove('no-padding');
    document.body.style.padding = '';
    document.body.style.margin = '';
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    },
    
    async fetchClassCounts() {
      try {
        const response = await this.$http.get(`/teachers/hasClass`);
        if (response.data && response.data.success) {
          this.boundClassCount = response.data.classCount || 0;
          this.maxClasses = response.data.maxClasses || 5;
        } else {
          this.boundClassCount = response.data.classCount || 0;
          this.maxClasses = response.data.maxClasses || 5;
        }
      } catch (error) {
        console.error('获取教师班级数量失败:', error);
        this.boundClassCount = 0;
        this.maxClasses = 5;
      }
    },
    
    onSubjectChange(subjectId) {
      if (subjectId) {
        this.initializeHomeworkTypesTree(subjectId);
      } else {
        this.treeData = [];
        this.expandedKeys = [];
      }
    },
    
    initializeHomeworkTypesTree(subjectId) {
      const subjectName = this.subjects.find(sub => sub.id === subjectId)?.name || '未知科目';
      
      let defaultTypes = [];
      if (subjectId === 1) { // 语文
        defaultTypes = [{ name: '听写本' }];
      } else if (subjectId === 2) { // 数学
        defaultTypes = [{ name: '计算题' }];
      } else if (subjectId === 3) { // 英语
        defaultTypes = [{ name: '听写本' }];
      } else { // 其他科目
        defaultTypes = [];
      }
      
      this.treeData = [{
        id: `subject_${subjectId}`,
        label: subjectName,
        type: 'subject',
        children: defaultTypes.map((type, index) => ({
          id: `type_${index}`,
          label: type.name,
          type: 'homework-type'
        }))
      }];
      
      this.expandedKeys = [`subject_${subjectId}`];
    },
    
    // 查找节点的父节点
    findParentNode(treeData, targetNode) {
      for (let i = 0; i < treeData.length; i++) {
        const item = treeData[i];
        if (item.children) {
          if (item.children.some(child => child.id === targetNode.id)) {
            return item;
          }
          // 递归查找
          const found = this.findParentNode(item.children, targetNode);
          if (found) return found;
        }
      }
      return null;
    },
    
    showAddHomeworkTypeDialog(parentData) {
      this.$prompt('请输入作业类型名称', '添加作业类型', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: '',
        inputPlaceholder: '请输入作业类型名称',
        inputValidator: (value) => {
          if (!value || value.trim() === '') return '请输入作业类型名称';
          if (value.length > 30) return '作业类型名称不能超过30个字符';
          // 检查是否存在同名的作业类型
          if (parentData.children && parentData.children.some(child => child.label.trim() === value.trim())) {
            return '该作业类型名称已存在，请输入不同的名称';
          }
          return true;
        },
        inputErrorMessage: '作业类型名称格式不正确',
        closeOnClickModal: false
      }).then(({ value }) => {
        if (!parentData.children) {
          this.$set(parentData, 'children', []);
        }
        
        const newType = {
          id: `type_${Date.now()}`,
          label: value.trim(),
          type: 'homework-type'
        };
        
        parentData.children.push(newType);
        this.$message.success('作业类型添加成功');
      }).catch(() => {
        // 用户取消操作
      });
    },
    
    renameNode(node, data) {
      // 找到当前节点的父节点
      const parentNode = this.findParentNode(this.treeData, data);
      
      this.$prompt('请输入新的作业类型名称', '重命名', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: data.label,
        inputValidator: (value) => {
          if (!value) return '请输入作业类型名称';
          if (value.length > 30) return '作业类型名称不能超过30个字符';
          // 检查是否存在同名的作业类型
          if (parentNode && parentNode.children && 
              parentNode.children.some(child => child.id !== data.id && child.label.trim() === value.trim())) {
            return '该作业类型名称已存在，请输入不同的名称';
          }
          return true;
        },
        inputErrorMessage: '作业类型名称格式不正确'
      }).then(({ value }) => {
        data.label = value;
      }).catch(() => {
        // 取消操作
      });
    },
    
    moveUp(node, data) {
      // 找到当前节点的父节点
      const parentNode = this.findParentNode(this.treeData, data);
      if (!parentNode || !parentNode.children) {
        return;
      }
      
      const siblings = parentNode.children;
      const index = siblings.findIndex(item => item.id === data.id);
      
      if (index > 0) {
        // 上移：与前一个元素交换位置
        [siblings[index - 1], siblings[index]] = [siblings[index], siblings[index - 1]];
        
        // 创建新的treeData副本以强制更新视图
        this.treeData = [...this.treeData];
      } else {
        this.$message.warning('此项已在顶部，无法上移');
      }
    },
    
    moveDown(node, data) {
      // 找到当前节点的父节点
      const parentNode = this.findParentNode(this.treeData, data);
      if (!parentNode || !parentNode.children) {
        return;
      }
      
      const siblings = parentNode.children;
      const index = siblings.findIndex(item => item.id === data.id);
      
      if (index < siblings.length - 1) {
        // 下移：与后一个元素交换位置
        [siblings[index], siblings[index + 1]] = [siblings[index + 1], siblings[index]];
        
        // 创建新的treeData副本以强制更新视图
        this.treeData = [...this.treeData];
      } else {
        this.$message.warning('此项已在底部，无法下移');
      }
    },
    
    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex(d => d.id === data.id);
      
      if (index !== -1) {
        children.splice(index, 1);
      }
    },
    isHomeworkTypeLimitReached(subjectData) {
      if (!subjectData.children) {
        return false;
      }
      return subjectData.children.length >= 20;
    },
    
    async handleJoinClass() {
      try {
        await this.$refs.joinClassForm.validate()
        this.loading = true
        
        // 获取当前登录教师信息
        const teacherInfo = JSON.parse(localStorage.getItem('teacherInfo'))
        if (!teacherInfo) {
          this.$message.error('请先登录')
          this.$router.push('/loginmobile')
          return
        }
        
        // 收集作业类型信息
        const homeworkTypes = [];
        if (this.treeData && this.treeData.length > 0) {
          // 遍历树数据，收集所有作业类型
          const collectHomeworkTypes = (nodes, currentIndex = 0) => {
            nodes.forEach(node => {
              if (node.type === 'homework-type') {
                // 只有作业类型节点才添加到列表
                homeworkTypes.push({
                  name: node.label,
                  subjectId: this.joinClassForm.subjectId,
                  sortOrder: currentIndex + 1
                });
                currentIndex++;
              } else if (node.children && node.children.length > 0) {
                // 如果有子节点，递归遍历
                currentIndex = collectHomeworkTypes(node.children, currentIndex);
              }
            });
            return currentIndex;
          };
          collectHomeworkTypes(this.treeData);
        }
        
        const response = await this.$http.post('/classes/join', {
          teacherId: teacherInfo.id,
          gradeLevel: this.joinClassForm.gradeLevel,
          classNumber: this.joinClassForm.classNumber,
          classCode: this.joinClassForm.classCode,
          subjectId: this.joinClassForm.subjectId,
          homeworkTypes: homeworkTypes
        })
        
        if (response.data.success) {
          this.$message.success(response.data.message)
          // 获取加入的班级ID并跳转到对应的班级首页，带上任教科目ID
          const joinedClassId = response.data.class.id;
          const subjectId = this.joinClassForm.subjectId;
          this.$router.push(`/mobile/class/${joinedClassId}?subjectId=${subjectId}`)
        } else {
          this.$message.error(response.data.message)
        }
      } catch (error) {
        console.error('加入班级失败:', error)
        this.$message.error('加入班级失败，请重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.join-class-mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #409EFF, #64b5f6);
  padding: 20px 10px; /* 上下20px，左右10px */
}

.join-class-card {
  width: 100%;
  max-width: 400px;
  border-radius: 15px;
  overflow: hidden;
}

.join-class-card ::v-deep .el-card__body {
  padding: 0;
}

.join-class-header {
  background: linear-gradient(90deg, #409EFF, #64b5f6);
  color: white;
  padding: 20px;
  margin: -20px -20px 20px -20px; /* 修正头部位置 */
}

.join-class-header h2 {
  margin: 10px 0 0 0;
  text-align: center;
}

.back-button {
  color: white;
  padding: 0;
  font-size: 14px;
}

.back-button:hover {
  color: #ffffff;
}

.teacher-info {
  margin-top: 10px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  line-height: 1.5;
}

.join-class-form {
  padding: 20px 10px; /* 左右10px */
}

.el-form-item {
  margin-bottom: 20px;
}

/* 调整标签宽度和输入框宽度 */
.el-form-item ::v-deep .el-form-item__label {
  width: 85px !important; /* 适中宽度避免换行，同时腾出横向空间 */
  white-space: nowrap !important; /* 防止标签文字换行 */
}

.el-form-item ::v-deep .el-form-item__content {
  margin-left: 85px !important; /* 调整内容的左边距与标签宽度保持一致 */
}

.full-width-btn {
  width: 100%;
  height: 45px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
}

.el-input__inner {
  height: 45px;
  line-height: 45px;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  padding: 0 15px;
  font-size: 14px;
}

.el-select {
  width: 100% !important; /* 增加下拉框宽度 */
}

.homework-types-container {
  width: 100%;
}

.homework-types-tree {
  border: 1px solid #dcdfe6;
  border-radius: 10px;
  padding: 10px 0px 10px 0px; /* 只去掉左右padding，保留上下padding */
  max-height: 300px;
  overflow-y: auto;
  margin-top: 5px;
}

/* 输入框样式增强 - 保持与项目规范一致 */
:deep(.el-input__inner) {
  font-size: 16px !important;
  font-weight: bold !important;
  border-radius: 8px !important;
}

:deep(.el-select .el-input__inner) {
  font-size: 16px !important;
  font-weight: bold !important;
  border-radius: 8px !important;
}

/* Element UI 表单样式 */
.el-form-item {
  margin-bottom: 22px;
}

.el-form-item__label {
  text-align: right;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}

.el-form-item__content {
  line-height: 40px;
  position: relative;
  font-size: 14px;
}

.el-form-item__content::after {
  clear: both;
}

.el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 0;
}

.el-form-item__required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

/* 自定义树节点样式 */
:deep(.custom-tree-node) {
  flex: 1 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  font-size: 14px;
  padding-right: 8px;
  width: 100% !important;
  min-width: 0; /* 确保flex项目可以缩小 */
}

:deep(.node-label) {
  flex: 1 !important;
  min-width: 0 !important; /* 允许文本缩小时收缩 */
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

:deep(.node-actions) {
  margin-left: 10px;
  display: flex !important;
  align-items: center !important;
}

/* 移动端适配 */
@media screen and (max-width: 480px) {
  .join-class-mobile {
    padding: 0;
  }
  
  .join-class-card {
    margin: 10px;
  }
  
  .join-class-header {
    padding: 20px;
    margin: -20px -20px 20px -20px;
  }
  
  .join-class-form {
    padding: 20px 10px; /* 保持与桌面端一致的左右10px */
  }
  
  .join-class-header h2 {
    font-size: 22px;
  }
  
  .el-input__inner {
    height: 42px;
    line-height: 42px;
    font-size: 14px;
    border-radius: 8px;
  }
  
  .full-width-btn {
    height: 42px;
    font-size: 15px;
  }
}
</style>